import { t } from 'i18next';
import { useColorMode } from '@chakra-ui/react';
import { ArrowRightSmall } from '@peacecover/icon';
import { formatDateTime } from '@pocapan/shared/utils/DateUtil';
import { attachJosa } from '@pocapan/shared/utils/bettieUtils';
import { BettieLetterStyle, commonFontFamily } from '../../../constants/BettieGradientColor';
import type { components } from '@pocapan/shared/types/schema';

type FanLetter = components['schemas']['ApiV1FanLetter'];

interface FanLetterFooterProps {
  isFanLetterOpen: boolean;
  fanLetter: FanLetter;
  handleOpenFanLetter: () => void;
}

const FanLetterFooter = ({
  isFanLetterOpen,
  fanLetter,
  handleOpenFanLetter
}: FanLetterFooterProps) => {
  const { colorMode } = useColorMode();

  if (isFanLetterOpen) {
    return (
      <div className="flex items-center gap-[8px] pb-[32px] pt-[27px] justify-center">
        <p className="text-[13px] leading-[30px] text-text-main-lv2" style={commonFontFamily}>
          {formatDateTime(fanLetter.writtenAt, 'PPP')}
        </p>
        <p className="text-[17px] leading-[30px] text-text-main-lv2" style={commonFontFamily}>
          {attachJosa(fanLetter.bettieNickname ?? '', '가/이가')}
        </p>
      </div>
    );
  }

  return (
    <div className="relative flex items-center justify-center z-[10] mb-[66px] mt-[-5px]">
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[103px] h-[39px] rounded-[40px]"
        style={BettieLetterStyle.fabButtonBlur[colorMode]}
      />
      <button
        type="button"
        onClick={handleOpenFanLetter}
        className="relative flex items-center gap-[4px] rounded-[100px] py-[11px] pl-[18px] pr-[14px] w-fit"
        style={BettieLetterStyle.fabButtonBackground}
      >
        <p className="text-[14px] font-semibold text-text-main-lv2 leading-[17px] dark:text-[#444444]">
          {t('BettieLetterDetail.openLetter')}
        </p>
        <ArrowRightSmall size={15} className="text-text-main-lv2 dark:text-[#444444]" />
      </button>
    </div>
  );
};

export default FanLetterFooter;
